<template>
  <template v-if="mode === 'edit'">
    <div class="py-3">
      <label v-if="field.label" for="input" class="block text-brand-black whitespace-pre-line">
        {{ field.label }}
      </label>
    </div>
  </template>
  <template v-if="mode === 'view'"> </template>
  <template v-if="mode === 'form_edit'">
    <template v-if="!textEdit">
      <div class="flex flex-col px-2 py-3 hover:bg-brand-light-gray w-full" @click="toggleTextEdit">
        <label
          for="input"
          class="inline-block text-brand-black whitespace-pre-line cursor-pointer"
          style="overflow-wrap: break-word"
        >
          {{ field.label || "Click to edit"
          }}<PencilIcon
            class="inline-block text-brand-dark-gray cursor-pointer w-5 h-5 ml-2"
            :class="[field.editable === false ? 'opacity-50 pointer-event-none' : 'cursor-pointer']"
          />
        </label>
      </div>
    </template>
    <template v-else>
      <form class="w-full" @submit.prevent="toggleTextEdit">
        <MultiLineInput :value="field.label" @input="updateText"></MultiLineInput>
        <p class="text-right text-brand-green cursor-pointer" @click="toggleTextEdit">done</p>
      </form>
    </template>
  </template>
</template>
<script>
import { PencilIcon } from "@heroicons/vue/solid"
export default {
  components: {
    PencilIcon
  },
  props: {
    field: Object,
    mode: {
      type: String
    },
    stage: {
      type: String
    }
  },
  computed: {
    isValid() {
      return true
    }
  },
  data() {
    return {
      textEdit: false
    }
  },
  methods: {
    toggleTextEdit() {
      if (this.field.editable === false) {
        return
      }
      this.textEdit = !this.textEdit
    },
    updateText(ev) {
      // eslint-disable-next-line vue/no-mutating-props
      this.field.label = ev.target.value
    }
  }
}
</script>
<style lang="scss" scoped></style>
